var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfLargeRegisterPageSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 257,
    viewBox: "0 0 507 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.2018 6.11909L0 44.7322L97.0043 50.4294L89.2018 6.11909ZM101.222 61.8235L30.5775 128.5L123.575 100.648L101.222 61.8235ZM131.378 110.143L87.7257 197.076L165.751 139.05L131.378 110.143ZM176.506 144.958L165.329 241.597L218.682 160.361L176.506 144.958ZM275.408 162.471H230.491L252.844 257L275.408 162.471ZM329.604 144.958L287.428 160.361L340.781 241.597L329.604 144.958ZM340.359 138.839L418.384 196.865L374.732 109.932L340.359 138.839ZM382.535 100.648L475.532 128.5L404.888 61.8235L382.535 100.648ZM409.105 50.4294L506.11 44.7322L416.908 6.11909L409.105 50.4294ZM389.283 0H116.827C116.827 75.3275 177.771 136.307 253.055 136.307C328.339 136.307 389.283 75.3275 389.283 0Z",
    fill: "#0089AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfLargeRegisterPageSun);
export default __webpack_public_path__ + "static/media/HalfLargeRegisterPageSun.675356fdd56c625fb35945d533704c1d.svg";
export { ForwardRef as ReactComponent };